import React from 'react';
import { Box, Text, VStack, Image, Link } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { DisplayHeading } from '../../components/ui';
import { ff } from '../../theme';

const EmailSentPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      minH="100svh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      bg="white"
      px={{ base: '20px', md: 6 }}
      py={{ base: 6, md: 10 }}
    >
      <Image
        src="https://firebasestorage.googleapis.com/v0/b/storyitapp.appspot.com/o/touchpoints%2FFoodFluence.io%20Logo%20(461%20x%20196%20px)%20(6).png?alt=media&token=54ec9ac5-6bd9-40e1-98c4-12597c3953a1"
        alt="FoodFluencer Logo"
        maxW="200px"
        objectFit="contain"
      />
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', flex: 1, width: '100%', maxWidth: 440 }}
      >
        <VStack spacing={3} align="stretch" textAlign="center">
          <DisplayHeading size="32px">We've sent you a link!</DisplayHeading>
          <Text fontSize="15px" color={ff.text2}>
            Please check your email to continue sign in.
            Don't forget to check your spam folder if you don't see it.
          </Text>
          <Text fontSize="15px" pt={6}>
            <Link as="button" color={ff.ink} fontWeight={600} textDecoration="underline" onClick={() => navigate('/login')}>
              Go back to login
            </Link>
          </Text>
        </VStack>
      </motion.div>
    </Box>
  );
};

export default EmailSentPage;
